import { FiLogOut, FiKey, FiList, FiFileText, FiBarChart2 } from "react-icons/fi";
import { Link, useLocation } from "react-router-dom";

function Header({ onLogout, onResetPassword, userName }) {
    const handleLogout = () => {
        localStorage.clear();
        if (onLogout) onLogout();
    };

    const handleResetPassword = () => {
        if (onResetPassword) onResetPassword();
    };

    const userRole = localStorage.getItem("Role");
    const location = useLocation();

    const tabs = [
        { name: "Dashboard", path: "/", icon: <FiBarChart2 />, visible: true },
        { name: "Consumers", path: "/consumers", icon: <FiList />, visible: true },
        { name: "Quotations", path: "/quotations", icon: <FiFileText />, visible: true },
    ];


    return (
        <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4 mb-4">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                {/* Logo + Title */}
                <div className="flex items-center gap-3">
                    <img src="/sv.jpg" alt="SV Solar Logo" className="h-14 object-contain" />
                    <div>
                        <h1 className="text-lg font-bold text-gray-800">Consumer Management System</h1>
                        <p className="text-xs text-gray-500">Manage all consumer records</p>
                    </div>
                </div>

                {/* User Actions */}
                <div className="flex items-center gap-3">
                    <div className="hidden sm:block text-sm text-right">
                        <div className="font-semibold text-gray-800">{userName}</div>
                        <div className="text-xs text-gray-500">{userRole}</div>
                    </div>

                    <button
                        onClick={handleResetPassword}
                        className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded-md text-sm flex items-center gap-1"
                        title="Reset Password"
                    >
                        <FiKey />
                        <span className="hidden sm:inline">Reset</span>
                    </button>

                    <button
                        onClick={handleLogout}
                        className="bg-red-600 hover:bg-red-700 text-white p-2 rounded-full shadow transition"
                        title="Logout"
                        aria-label="Logout"
                    >
                        <FiLogOut className="text-lg" />
                    </button>
                </div>
            </div>

            {/* NAVIGATION */}
            <nav className="sticky top-0 z-40 w-full mt-2 bg-gradient-to-r from-orange-600 to-amber-400 shadow-md rounded-lg">
                <div className="px-6">
                    <div className="flex items-center gap-2 h-12 text-sm font-medium">
                        {tabs.map((tab) => {
                            const isActive =
                                tab.path === "/"
                                    ? location.pathname === "/"
                                    : location.pathname.startsWith(tab.path);

                            return (
                                <Link
                                    key={tab.path}
                                    to={tab.path}
                                    className={`flex items-center gap-2 px-4 py-2 rounded-lg transition
              ${isActive
                                            ? "bg-white/30 text-white font-semibold"
                                            : "text-yellow-100 hover:bg-white/20 hover:text-white"
                                        }
            `}
                                >
                                    {tab.icon}
                                    <span>{tab.name}</span>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </nav>

        </header>
    );
}

export default Header;
